import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Feature } from '../Feature.mjs';
import { observeIntersection } from './observers.mjs';
var thresholdNames = {
  some: 0,
  all: 1
};
var InViewFeature = /*#__PURE__*/function (_Feature) {
  function InViewFeature() {
    var _this;
    _classCallCheck(this, InViewFeature);
    _this = _callSuper(this, InViewFeature, arguments);
    _this.hasEnteredView = false;
    _this.isInView = false;
    return _this;
  }
  _inherits(InViewFeature, _Feature);
  return _createClass(InViewFeature, [{
    key: "startObserver",
    value: function startObserver() {
      var _this2 = this;
      this.unmount();
      var _this$node$getProps = this.node.getProps(),
        _this$node$getProps$v = _this$node$getProps.viewport,
        viewport = _this$node$getProps$v === void 0 ? {} : _this$node$getProps$v;
      var root = viewport.root,
        rootMargin = viewport.margin,
        _viewport$amount = viewport.amount,
        amount = _viewport$amount === void 0 ? "some" : _viewport$amount,
        once = viewport.once;
      var options = {
        root: root ? root.current : undefined,
        rootMargin: rootMargin,
        threshold: typeof amount === "number" ? amount : thresholdNames[amount]
      };
      var onIntersectionUpdate = function onIntersectionUpdate(entry) {
        var isIntersecting = entry.isIntersecting;
        /**
         * If there's been no change in the viewport state, early return.
         */
        if (_this2.isInView === isIntersecting) return;
        _this2.isInView = isIntersecting;
        /**
         * Handle hasEnteredView. If this is only meant to run once, and
         * element isn't visible, early return. Otherwise set hasEnteredView to true.
         */
        if (once && !isIntersecting && _this2.hasEnteredView) {
          return;
        } else if (isIntersecting) {
          _this2.hasEnteredView = true;
        }
        if (_this2.node.animationState) {
          _this2.node.animationState.setActive("whileInView", isIntersecting);
        }
        /**
         * Use the latest committed props rather than the ones in scope
         * when this observer is created
         */
        var _this2$node$getProps = _this2.node.getProps(),
          onViewportEnter = _this2$node$getProps.onViewportEnter,
          onViewportLeave = _this2$node$getProps.onViewportLeave;
        var callback = isIntersecting ? onViewportEnter : onViewportLeave;
        callback && callback(entry);
      };
      return observeIntersection(this.node.current, options, onIntersectionUpdate);
    }
  }, {
    key: "mount",
    value: function mount() {
      this.startObserver();
    }
  }, {
    key: "update",
    value: function update() {
      if (typeof IntersectionObserver === "undefined") return;
      var _this$node = this.node,
        props = _this$node.props,
        prevProps = _this$node.prevProps;
      var hasOptionsChanged = ["amount", "margin", "root"].some(hasViewportOptionChanged(props, prevProps));
      if (hasOptionsChanged) {
        this.startObserver();
      }
    }
  }, {
    key: "unmount",
    value: function unmount() {}
  }]);
}(Feature);
function hasViewportOptionChanged(_ref) {
  var _ref$viewport = _ref.viewport,
    viewport = _ref$viewport === void 0 ? {} : _ref$viewport;
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref2$viewport = _ref2.viewport,
    prevViewport = _ref2$viewport === void 0 ? {} : _ref2$viewport;
  return function (name) {
    return viewport[name] !== prevViewport[name];
  };
}
export { InViewFeature };